angular.module('angus.controllers').controller('arSummarySubRegSettingsCtrl', [
    '$scope', 'promiseMonitor', '$q',
    function($scope, promiseMonitor, $q) {
    }
]);